import { render, staticRenderFns } from "./UserInfoAfter.vue?vue&type=template&id=c4fe9f70&scoped=true&"
import script from "./UserInfoAfter.vue?vue&type=script&lang=js&"
export * from "./UserInfoAfter.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoAfter.vue?vue&type=style&index=0&id=c4fe9f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fe9f70",
  null
  
)

export default component.exports